'use client'

import { Box, Container } from '@chakra-ui/react'
import Carousel from '../Carousel'

import PopupDisplayer from '@/_components/PopupDisplayer'
import { IBanner, IBranch, ICategory, IStocks } from '@/_types'
import AlertWorkingHours from '@/_components/AlertWorkingHours'
import Brands from '../Brands'
import CashbackQR from '../CashbackQR'
import CategoriesList from '../CategoriesList'
import NightFeeding from '../NightFeeding'
import Products from '../Products'
import Stocks from '../Stocks'
import ReviewOrder from './review-order'
import type { ShipperCategoryResponse } from '@/_service/shipper-category.service'
import type { IProduct } from '@/entities/product/model/types'

interface HomeContentProps {
  shipper_id: string | null
  banners?: { banners?: IBanner[] } | null
  popups?: { popups?: any[] } | null
  promos?: { promos?: IStocks[]; count?: number | string } | null
  initialShipperCategories?: ShipperCategoryResponse | null
  initialMainCategories?: ICategory[]
  initialSectionProducts?: Record<
    string,
    { products: IProduct[]; count: number }
  >
  initialNightFeeding?: { branches: IBranch[]; count: number } | null
}

function HomeContent({
  shipper_id,
  banners: bannersData,
  popups: popupsData,
  promos: promosData,
  initialShipperCategories,
  initialMainCategories,
  initialSectionProducts,
  initialNightFeeding,
}: HomeContentProps) {
  const banners = bannersData?.banners
  const popups = popupsData?.popups

  return (
    <Box as='main' maxW='100vw' overflow='hidden'>
      {banners?.length ? (
        banners.length <= 2 ? (
          <Container
            px={{ base: 0, lg: 10 }}
            pt={{ base: 2 }}
            pb={{ base: 4 }}
            m={0}
            mx='auto'
          >
            <Carousel list={banners} />
          </Container>
        ) : (
          <Carousel list={banners} />
        )
      ) : null}

      <CashbackQR />

      <Box>
        <Container mt={{ base: 6, lg: 0 }}>
          <AlertWorkingHours />
        </Container>
        <CategoriesList
          shipperId={shipper_id}
          initialData={initialShipperCategories}
        />
        <Brands shipperId={shipper_id} />
        <Stocks promos={promosData} />
        <Products
          initialCategories={initialMainCategories}
          initialSectionProducts={initialSectionProducts}
        />
        <NightFeeding initialData={initialNightFeeding} />
      </Box>

      {popups && <PopupDisplayer popups={popups} />}
      <ReviewOrder />
    </Box>
  )
}

export default HomeContent
